<div class="g-layout__container">
    <div>
        <div class="g-c-primaryDarkerColor font-bold mb-3">
            الإشعارات
        </div>
        <div class="br"></div>
    </div>
    <div class="notification-menu ">

        <ul>
            @for (notification of notifications; track $index) {
            <li (click)="handleNotificationClick(notification)" class=" relative cursor-pointer"
                ngClass="{{notification.is_read?'read':'unread'}}">
                <div class="p-2" ngClass="{{notification.is_read?'read_hover':''}}">
                    <div class="flex gap-2 align-items-center">
                        <div class="text-xl ">
                            <i class="fa-solid fa-user"></i>
                        </div>
                        <div>
                            {{ notification.sender_name}}
                        </div>
                    </div>
                    <div class="line-height-4 text-xs ">
                        {{notification.header}}
                    </div>
                    <span class="mt-2 text-xs" ngClass="{{!notification.is_read?'unread':''}}">
                        {{notification.created_at | sinceDate}}
                    </span>
                    @if(!notification.is_read){

                    <div class="unread__circle">

                    </div>
                    }
                </div>
            </li>


            }

        </ul>
    </div>
</div>